import React, { useReducer, useContext } from "react";
import { topicCategoryReducer as reducer } from "../reducers/topicCategoryReducer";
import { topicCategoryActions as actions } from "../actions/topicCategoryActions";

const initialValue = {
  topicCategories: null,
  showModal: false,
  currentTopicCategory: null,
};

const topicCategoryContext = React.createContext();

const TopicCategoryContext = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialValue);

  return (
    <topicCategoryContext.Provider value={{ state, dispatch, actions }}>
      {children}
    </topicCategoryContext.Provider>
  );
};

export const useTopicCategoryContext = () =>
  React.useContext(topicCategoryContext);
export default TopicCategoryContext;
